import { IAPIResponse } from "../interfaces/api";

export const wait = async (timeout: number): Promise<void> => {
    await new Promise(executor => setTimeout(executor, timeout));
}

export const getQueryParameter = (parameter: string): string | null => {
    const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
    return urlParams.get(parameter);
}

export const formatURL = (url: string): string => {
    let _url: string = url;

    if (_url.endsWith('/') === false) {
        _url = `${_url}/`;
    }

    return _url;
}

export const generateRandomInt32Number = (): number => {
    const min = -2147483648;
    const max = 2147483647;

    return Math.ceil(Math.random() * (max - min) + min);
}

export const checkAPIResponse = <Type>(response: IAPIResponse<Type>): { status: boolean, message: string | undefined | Error | null } => {
    if (response.status === true && response.error == null) {
        if (response.response != null && response.response.statusCode === 200) {
            return { status: true, message: undefined };
        }
        else {
            return { status: false, message: `${response.response?.statusCode} - ${response.response?.message}` };
        }
    }
    else if (response.status === false) {
        if (response.response != null) {
            return { status: false, message: `${response.response?.statusCode} - ${response.response?.message}` };
        }
        else {
            return { status: false, message: response.error?.message }
        }
    }
    else {
        return { status: false, message: response.error?.message }
    }
}